module.exports = __webpack_public_path__ + "static/media/watercooler-2x.5a5d2418.png";